var map = {
	"./1AGP.png": 75667,
	"./2AGP.png": 63,
	"./3AGP.png": 77688,
	"components/Catalog/AGP/img/glass/mt/mtPlusGold/1AGP.png": 75667,
	"components/Catalog/AGP/img/glass/mt/mtPlusGold/2AGP.png": 63,
	"components/Catalog/AGP/img/glass/mt/mtPlusGold/3AGP.png": 77688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14866;